<template>
  <div id="app" class="main-container">
    <Login v-if="!$store.state.is_login" />
    <div class="main-wrapper" v-if="$store.state.is_login">
      <Loading v-if="$store.state.level1.isLoading" />
      <Alert v-if="$store.state.alert" />

      <ModaLProfile :status="$store.state.modalStore.profile" />
      <AdvanceSearch :status="$store.state.modalStore.advanceSearch" />
      <ModalKbli v-if="$store.state.modalStore.kbli" />
      <ModalIujp v-if="$store.state.modalStore.iujp" />
      <ModalSbujk v-if="$store.state.modalStore.sbujk" />
      <ModalIujptl v-if="$store.state.modalStore.iujptl" />
      <ModalInubbm v-if="$store.state.modalStore.inubbm" />
      <ModalSiupal v-if="$store.state.modalStore.siupal" />

      <!-- <ModalCategory v-if="$store.state.modalStore.category" /> -->

      <Navbar />

      <div
        class="category-mobile-class"
        v-if="$store.state.modalStore.categoryMobile"
      >
        <ModalCategoryMobile />
      </div>

      <div>
        <div>
          <router-view />
        </div>
      </div>
      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/utils/Navbar'
import Footer from '@/components/utils/footer'

import axios from 'axios'

export default {
  head: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
      },
    ],
  },
  components: {
    Loading: () => import('@/components/utils/Loading'),
    Navbar,
    Footer,
    ModaLProfile: () => import('@/components/Organism/CompanyProfile.vue'),
    AdvanceSearch: () => import('@/components/ModalAdvanceSearch.vue'),
    ModalKbli: () => import('@/components/Modal/Kbli'),
    ModalIujp: () => import('@/components/Modal/Iujp'),
    ModalSbujk: () => import('@/components/Modal/Sbujk'),
    ModalIujptl: () => import('@/components/Modal/Iujptl'),
    ModalInubbm: () => import('@/components/Modal/Inubbm'),
    ModalSiupal: () => import('@/components/Modal/Siupal'),
    ModalCategory: () => import('@/components/Modal/Category'),
    Alert: () => import('@/components/Modal/Alert'),
    Login: () => import('@/views/V2/Login'),
    ModalCategoryMobile: () => import('@/components/Modal/CategoryMobile'),
  },
  async created() {
    const self = this
    let token = self.$router.currentRoute.query.token
    if (token) {
      this.$store.commit('SET_TOKEN', token)

      await this.getPermissions(token)
      await self.$router.push('/')
    }
    await self.$store.commit('AUTO_LOGIN')
    await self.$store.dispatch('getSlides')
  },
  methods: {
    async getPermissions() {
      this.$store.commit('setLoading', true)
      const token = localStorage.getItem('token')
      try {
        const { data } = await axios({
          method: 'GET',
          // url: `${process.env.VUE_APP_API}/api/v1/user/user-permissions`,
          url: `${process.env.VUE_APP_API}/api/v1/auth/permissions/${this.$store.state.userid}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })

        if (data && data.status == 'success') {
          this.$store.commit('setLoading', false)
          console.log('get permission: ', data.data)
          this.$store.commit('SET_PERMISSIONS', data.data.permission)
          if (data.data.kode && data.data.kode.length > 0) {
            this.$store.commit('SET_KODE', data.data.kode)
          }
        }
      } catch (error) {
        console.log('error', error)
        this.$store.commit('setLoading', false)
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
}
</script>
